const brickCreationScript = `
  if(window.brandBrickController) {
    window.brandBrickController.unmount();
  }

  const mp = new MercadoPago(window.brandBricksProps.publicKey, {
    locale: window.brandBricksProps.language,
    trackingDisabled: true
  });

  const bricksBuilder = mp.bricks();
  const renderbrandBrick = async (bricksBuilder) => {

    const settings = {
      customization: {
        text: {
          valueProp: window.brandBricksProps.text.valueProp,
          align: window.brandBricksProps.text.align,
          useCustomFont: window.brandBricksProps.text.useCustomFont,
          size: window.brandBricksProps.text.size,
          fontWeight: window.brandBricksProps.text.fontWeight,
          color: window.brandBricksProps.text.color,
        },
        paymentMethods: {
          excludedPaymentMethods: window.brandBricksProps.paymentMethods.excludedPaymentMethods,
          excludedPaymentTypes:  window.brandBricksProps.paymentMethods.excludedPaymentTypes,
          maxInstallments:  window.brandBricksProps.paymentMethods.maxInstallments,
          interestFreeInstallments:  window.brandBricksProps.paymentMethods.interestFreeInstallments,
        },
        visual: {
          backgroundColor: window.brandBricksProps.visual.backgroundColor,
          hideMercadoPagoLogo: window.brandBricksProps.visual.hideMercadoPagoLogo,
          border: window.brandBricksProps.visual.border,
          borderColor: window.brandBricksProps.visual.borderColor,
          contentAlign: window.brandBricksProps.visual.contentAlign,
          borderWidth: window.brandBricksProps.visual.borderWidth,
          borderRadius: window.brandBricksProps.visual.borderRadius,
          verticalPadding: window.brandBricksProps.visual.verticalPadding,
          horizontalPadding: window.brandBricksProps.visual.horizontalPadding,
        },
      },
    };
    window.brandBrickController = await bricksBuilder.create('brand', 'brandBrick_container', settings);
  };
  renderbrandBrick(bricksBuilder);
  `;

const allPaymentMethods = ['master', 'visa', 'amex', 'naranja', 'maestro', 'cabal', 'cencosud', 'cordobesa', 'argencard', 'diners', 'tarshop', 'cmr', 'rapipago', 'pagofacil'];
const allPaymentTypes = ['credit_card', 'debit_card', 'ticket'];

module.exports = { brickCreationScript, allPaymentMethods, allPaymentTypes };
